import styled from 'styled-components'

export const Wrapper = styled.section`
  padding: 0;

  @media screen and (min-width: ${props => props.theme.responsive.large}) {
    padding: 30px;
  }
`

export const Grid = styled.ul`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-width: 1100px;
  margin: -10px auto;
`

export const GridItem = styled.li`
  margin: 10px 0;
  background-color: #f9f9f9;
  text-align: center;
  padding: 25px;
  width: 100%;

  @media screen and (min-width: ${props => props.theme.responsive.large}) {
    width: calc(50% - 20px);
    margin: 10px;
  }
`

export const GridItemTitle = styled.h3`
  line-height: 1;
  margin-top: 1ch;
`

export const GridItemDescription = styled.p`
  margin: 1em 0;
`

export const PartnerGrid = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: -.8ch;
`

export const PartnerGridItem = styled.li`
  margin: .8ch;
  height: 70px;
  width: 70px;

  @media screen and (min-width: ${props => props.theme.responsive.large}) {
    width: 110px;
  }
`

export const PartnerGridLink = styled.a`
  display: flex;
  width: 100%;
  height: 100%;
  border: 1px solid #b9b9b9;
  border-radius: 7px;
  align-items: center;
  justify-content: center;

  &:after {
    display: none;
  }

  &:hover {
    background: linear-gradient(to bottom, #cacaca 0%, #efefef 30%, #efefef 70%, #cacaca 100%);
  }
`

export const PartnerGridImage = styled.img`
  max-width: 90%;
  max-height: 90%;
  width: auto;
  height: auto;
`
